import React, { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { Context } from "../layout";

const PrivateRoute = ({ children }) => {
  const { store } = useContext(Context);
  const location = useLocation();
  return store.token ? (
    children
  ) : (
    <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />
  );
};

export default PrivateRoute;
